import Vue from 'vue';
import moment from 'moment';
import feesReportTransformer from './../../transformers/feesReport';

const success = ({ data }, resolve) => {
  const report = feesReportTransformer.fetchCollection(data.data);

  resolve(report);
};

const failed = (error, reject) => reject(error);


export default (feesMonth, clientId = null, limit = null) => (
  new Promise((resolve, reject) => {
    let url = '/reports/fees';
    const query = [];

    if (limit) {
      query.push(`limit=${limit}`);
    }

    if (clientId && clientId !== '') {
      query.push(`client_id=${clientId}`);
    }

    query.push(`start=${moment(feesMonth).startOf('month').format('YYYY-MM-DD')}`);
    query.push(`end=${moment(feesMonth).endOf('month').format('YYYY-MM-DD')}`);

    if (query.length > 0) {
      url += '?';
      query.map((q) => {
        url += `${q}&`;
        return q;
      });
      url = url.substring(0, url.length - 1);
    }

    Vue.$http.get(url)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/fees.js